import useIsServer from "@/Hooks/useIsServer";
import FsLightbox from "fslightbox-react";
import { ElementType, ReactElement, ReactNode, useEffect, useRef, useState } from "react";
import { SwiperProps } from "swiper/react";

const InteriorsGridSlider = ({ images }: { images: string[] }) => {
    const isServer = useIsServer();

    const swiperRef = useRef() as any;

    const ligthboxImages: ReactElement[] = [];
    
    images.forEach((image, i) => {
        ligthboxImages.push(
            <img
                srcSet={image}
                className="w-full object-cover cursor-pointer"
                alt={`Zdjęcie ${i+1}`}
                width={1920}
                height={1080}
            />
        )
    })

    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        slide: 1,
    });

    function openLightboxOnSlide(number: number) {
        setLightboxController({
            toggler: !lightboxController.toggler,
            slide: number,
        });
    }

    const hideHeader = () => {
        if(!isServer){
            document.querySelector('.sticky.top-0.z-50.w-full')?.classList.add('hidden');
        }
    };

    const showHeader = () => {
        if(!isServer){
            document.querySelector('.sticky.top-0.z-50.w-full')?.classList.remove('hidden');
        }
    };

    useEffect(() => {
        const swiperContainer = swiperRef.current;

        if (!swiperContainer) return;

        const params: SwiperProps = {
            speed: 750,
            autoplay: {
                delay: 8000,
            },
            slidesPerView: 1,
            spaceBetween: 24,
            loop: false,
            pagination: {
                el: ".swiper-pagination-grid",
                clickable: true,
                renderBullet: (index, className) => {
                    return `<div class="${className} custom-pagination-dot"></div>`;
                },
            },
        };

        Object.assign(swiperContainer, params);
        swiperContainer.initialize();
    }, [swiperRef])
    
    return (
        <div className="relative">
            <FsLightbox
                toggler={lightboxController.toggler}
                sources={ligthboxImages}
                slide={lightboxController.slide}
                onShow={hideHeader}
                onInit={hideHeader}
                onClose={showHeader}
            />
            <swiper-container ref={swiperRef} init={false} pagination>
                {Array.from({ length: Math.ceil(images.length / 4) }).map((_, slideIndex) => (
                    <swiper-slide key={slideIndex}>
                        <div className="grid grid-cols-2 grid-rows-2 md:gap-6 gap-2">
                            <img
                                srcSet={images[slideIndex * 4] || ''}
                                className="w-full object-cover cursor-pointer"
                                alt="Zdjęcie"
                                width={715}
                                height={170}
                                onClick={() => openLightboxOnSlide(slideIndex * 4 + 1 || 1)}
                            />
                            <img
                                srcSet={images[slideIndex * 4 + 1] || ''}
                                className="w-full object-cover cursor-pointer"
                                alt="Zdjęcie"
                                width={715}
                                height={170}
                                onClick={() => openLightboxOnSlide(slideIndex * 4 + 2)}
                            />
                            <img
                                srcSet={images[slideIndex * 4 + 2] || ''}
                                className="w-full object-cover cursor-pointer"
                                alt="Zdjęcie"
                                width={715}
                                height={170}
                                onClick={() => openLightboxOnSlide(slideIndex * 4 + 3)}
                            />
                            <img
                                srcSet={images[slideIndex * 4 + 3] || ''}
                                className="w-full object-cover cursor-pointer"
                                alt="Zdjęcie"
                                width={715}
                                height={170}
                                onClick={() => openLightboxOnSlide(slideIndex * 4 + 4)}
                            />
                        </div>
                    </swiper-slide>
                ))}
            </swiper-container>
            <div className="px-20 w-full mt-5">
                <div className="flex gap-x-3">
                    <div className="swiper-pagination-grid flex gap-x-3 justify-center mx-auto"></div>
                </div>
            </div>
        </div>
    )
}

export default InteriorsGridSlider;